export function getLinearGradientFromGradientArray(gradients = []) {
    let item = []
    gradients.forEach(element => {
        item.push(`${element.color} ${element.stop}% `)
    });
    return `linear-gradient(90deg, ${item.join(',')})`
}

export function getColorAtPercentage(gradient, percentage)  {
    const stops = gradient.match(/#[0-9A-Fa-f]{6}\s+\d+%?/g);
    const positions = stops.map(stop => parseFloat(stop.match(/\d+(\.\d+)?/)[0]));

    // Find the two color stops surrounding the percentage
    let index = 0;
    while (positions[index] < percentage && index < positions.length - 1) {
        index++;
    }

    const lowerStop = stops[index - 1] || stops[0];
    const upperStop = stops[index] || stops[stops.length - 1];

    const lowerColor = lowerStop.match(/#[0-9A-Fa-f]{6}/)[0];
    const upperColor = upperStop.match(/#[0-9A-Fa-f]{6}/)[0];

    const lowerPosition = positions[index - 1] || 0;
    const upperPosition = positions[index] || 100;

    const t = (percentage - lowerPosition) / (upperPosition - lowerPosition);

    // Interpolate between the two colors
    const color = interpolateColor(lowerColor, upperColor, t);

    return color;
}

// Function to interpolate color
function interpolateColor(startColor, endColor, ratio) {
    const startR = parseInt(startColor.substring(1, 3), 16);
    const startG = parseInt(startColor.substring(3, 5), 16);
    const startB = parseInt(startColor.substring(5, 7), 16);

    const endR = parseInt(endColor.substring(1, 3), 16);
    const endG = parseInt(endColor.substring(3, 5), 16);
    const endB = parseInt(endColor.substring(5, 7), 16);

    const r = Math.round(startR + (endR - startR) * ratio);
    const g = Math.round(startG + (endG - startG) * ratio);
    const b = Math.round(startB + (endB - startB) * ratio);

    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}


export function extractPercentageFromString(str) {
    const regex = /(\d+(\.\d+)?)(?=%)/;
    const match = str.match(regex);
    if (match) {
        return parseFloat(match[0]);
    } else {
        return null; // Return null if no percentage value is found
    }
}
